module.exports = __webpack_public_path__ + "img/cards.aa9e5f1.svg";